import BigNumber from "bignumber.js";
import { ContactType } from "src/main/types";
import { SimpleMap } from "src/main/utils";
export const USERNAME_LOGIN = false;
export const LINE_SUPPORT_LINK = "https://line.me/R/ti/p/@645ojnqc";
export const FACEBOOK_SUPPORT_LINK = "https://www.facebook.com/ilovevipth/";
export const TELEGRAM_SUPPORT_LINK = "https://t.me/ILV_PH_bot";

// export const SOCIAL_MEDIA_CHANNEL = {
//   Facebook: FACEBOOK_SUPPORT_LINK,
//   LINE: LINE_SUPPORT_LINK,
//   Telegram: TELEGRAM_SUPPORT_LINK,
// } as const;

export const SOCIAL_MEDIA_TYPE = {
  Facebook: "Facebook",
  Telegram: "Telegram",
  LINE: "LINE",
  Messenger: "Messenger",
};

export const PH_SOCIAL_MEDIAS = {
  Messenger: "https://m.me/200969406423049",
  Telegram: "https://t.me/ILV_PH_bot",
};

export const TH_SOCIAL_MEDIAS = {
  LINE: "https://line.me/R/ti/p/@645ojnqc",
  Facebook: "https://www.facebook.com/ilovevipth/",
};

export enum PROMO_BANNER_ACTION_TYPE {
  NOT_ACTION = 1,
  SITE_URL = 2,
  DISPLAY_VIP_SITE = 3,
}

export const PHONE_WITH_11_DIGITS = ["63"];

export const PHONE_WITH_10_DIGITS = ["66"];

/**
 * @deprecated use application config
 */
export const allDomainNames: SimpleMap<SimpleMap> = {
  TH: {
    ILV_TH: "ilovevip.com",
    TH_WOW99: "wow99vip.com",
    TH_XO666: "xo666vip.com",
    TH_DEE99: "dee99vip.com",
    TH_BIG666: "big666vip.com",
    TH_BOOM88: "boom88vip.com",
    TH_GOOD777: "good777vip.com",
    TH_MOO555: "moo555vip.com",
    TH_WINT9: "wint9vip.com",
    TH_XOGO: "xogovip.com",
    TH_CHAIYO268: "chaiyo268vip.com",
    TH_KBK99: "kbk99vip.com",
    TH_WOW268: "wow268vip.com",

    TH_KBK99_2: "kbk99vipp.com",
    TH_MOO555_2: "moo555vipp.com",
    TH_CHAIYO268_2: "chaiyo268vipp.com",
    TH_WOW268_2: "wow268vipp.com",
    TH_BIG666_2: "big666vipp.com",
  },
  PH: {
    ILV_PH: "ilovevipph.com",
    PH_WINHQ: "winhqvip.com",
    PH_EZJILI: "ezjilivip.com",
    PH_XOJILI: "xojilivip.com",
    PH_WOWJILI: "wowjilivip.com",

    PH_WINHQ_2: "winhqvipp.com",
    PH_EZJILI_2: "ezjilivipp.com",
    PH_XOJILI_2: "xojilivipp.com",
    PH_WOWJILI_2: "wowjilivipp.com",

    PH_EZJILI_AD: "ezjiliilvph.com",
    PH_XOJILI_AD: "xojiliilvph.com",
    PH_WINHQ_AD: "winhqilvph.com",
  },
  Staging: {
    ILV_STAGING: "vip.99tech.co",
    STAGING_BRAND: "vip-brand.99tech.co",
  },
};

/**
 * @deprecated use application config
 */
export const allBrandMaps = {
  [allDomainNames.TH.TH_WOW99]: "wow99",
  [allDomainNames.TH.TH_XO666]: "xo666",
  [allDomainNames.TH.TH_DEE99]: "dee99",
  [allDomainNames.TH.TH_BIG666]: "big666",
  [allDomainNames.TH.TH_BOOM88]: "boom88",
  [allDomainNames.TH.TH_GOOD777]: "good777",
  [allDomainNames.TH.TH_MOO555]: "moo555",
  [allDomainNames.TH.TH_WINT9]: "wint8",
  [allDomainNames.TH.TH_XOGO]: "xogo",
  [allDomainNames.TH.TH_CHAIYO268]: "chaiyo268",
  [allDomainNames.TH.TH_KBK99]: "kbk99",
  [allDomainNames.TH.TH_WOW268]: "wow268",

  [allDomainNames.TH.TH_KBK99_2]: "kbk99",
  [allDomainNames.TH.TH_MOO555_2]: "moo555",
  [allDomainNames.TH.TH_CHAIYO268_2]: "chaiyo268",
  [allDomainNames.TH.TH_WOW268_2]: "wow268",
  [allDomainNames.TH.TH_BIG666_2]: "big666",

  [allDomainNames.PH.PH_WINHQ]: "winhq",
  [allDomainNames.PH.PH_EZJILI]: "ezjili",
  [allDomainNames.PH.PH_XOJILI]: "xojili",
  [allDomainNames.PH.PH_WOWJILI]: "wowjili",

  [allDomainNames.PH.PH_WINHQ_2]: "winhq",
  [allDomainNames.PH.PH_EZJILI_2]: "ezjili",
  [allDomainNames.PH.PH_XOJILI_2]: "xojili",
  [allDomainNames.PH.PH_WOWJILI_2]: "wowjili",

  [allDomainNames.PH.PH_EZJILI_AD]: "ezjili",
  [allDomainNames.PH.PH_XOJILI_AD]: "xojili",
  [allDomainNames.PH.PH_WINHQ_AD]: "winhq",

  [allDomainNames.Staging.STAGING_BRAND]: "wow99",
};

export const deployCountries = {
  TH: "th",
  PH: "ph",
};

export const countryCodes = {
  TH: 66,
  PH: 63,
};

export const countryCurrency = {
  TH: "THB",
  PH: "PHP",
};

export const PRESET_EXCHANGE_RATE = [
  {
    credit: 88,
    point: 1188,
    bonus: 0,
  },
  {
    credit: 888,
    point: 9888,
    bonus: 20,
    tier: "one",
  },
  {
    credit: 4588,
    point: 48888,
    bonus: 25,
    tier: "three",
  },
  {
    credit: 18888,
    point: 188888,
    bonus: 35,
    tier: "four",
  },
  {
    credit: 108888,
    point: 888888,
    bonus: 65,
    tier: "five",
  },
];

export const PRESET_PH_EXCHANGE_RATE = [
  {
    credit: 88,
    point: 1188,
    bonus: 0,
  },
  {
    credit: 888,
    point: 9888,
    bonus: 20,
    tier: "one",
  },
  {
    credit: 4588,
    point: 48888,
    bonus: 25,
    tier: "three",
  },
  {
    credit: 18888,
    point: 188888,
    bonus: 35,
    tier: "four",
  },
  {
    credit: 108888,
    point: 888888,
    bonus: 65,
    tier: "five",
  },
];

export const FB_PIXEL_STORAGE_KEY = "ilv-pixel-storage-key:";
export const Defaults = {
  AccessTokenKey: "VIP_TOKEN",
  // LoginPhoneKey: "ILV_STORED_LOGIN_PHONE",
  BrandKey: "ILV_BRAND_INFO",
  ShoppingCardKey: "ILV_SHOPPING_CART",
  PopupBannerHistoryKey: "ILV_POPUP_BANNER_HISTORY",
  VoluumCidKey: "V_CID",
};

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const PUSH_NOTIFICATION_MEMBER_STORAGE_KEY = "push-notification-member-register";
export const REGISTERED = "REGISTERED";

export const FULFILMENT_TYPE = {
  Delivery: "delivery",
  SelfCollect: "self-collect",
  Virtual: "virtual",
};

export const TOP_PRODUCT_SLUG = "top-product";

export const DEFAULT_PRODUCT_IMAGE_URL = "/images/products/placeholder.svg";

export const SOCIAL_NETWORKS: SimpleMap<ContactType[]> = {
  [deployCountries.PH]: [
    {
      type: SOCIAL_MEDIA_TYPE.Messenger,
      url: PH_SOCIAL_MEDIAS.Messenger,
      title: "Messenger",
    },
    {
      type: SOCIAL_MEDIA_TYPE.Telegram,
      url: PH_SOCIAL_MEDIAS.Telegram,
      title: "Telegram",
    },
  ],
  [deployCountries.TH]: [{ type: SOCIAL_MEDIA_TYPE.LINE, url: TH_SOCIAL_MEDIAS.LINE, title: "Line" }],
};
